// @ts-nocheck
import {
  Grid,
  TextField,
  Typography,
  Button
} from "@material-ui/core";
import axios from "axios";
import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { Badge } from "@mui/material";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { SERVER_IP, PrimaryColor } from "../../variables";
import { useNavigate } from "react-router-dom";
import { Sidebar } from "../Sidebar";
import CircularProgress from '@mui/material/CircularProgress';
import { base64Converter, dateFormat, getCurrentUserID, getDateTime, inputFieldVariant, removeBadgeStyle, siteImages } from "../../utils";
import { useForm, Controller } from 'react-hook-form';
import pdfIcon from '../../assert/pdf_icon.png'
import docIcon from '../../assert/document_icon.png'
import ImageViewer from "../../assert/ImageViewer";
import { Container, Row, Col } from 'react-bootstrap'
import { DatePicker, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";

export const AddDoc = () => {

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false)
  const [uploadedFiles, setUploadedFiles] = useState<Array<any>>([]);
  const [imagePreview, setImagePreview] = useState<any>(null);
  const [showImagePreview, setShowImagePreview] = useState<Boolean>(false);
  const [documentDate, setDocumentDate] = useState<any>(null);

  const { handleSubmit, control } = useForm();

  const createDoc = async (data) => {
    if (!!!uploadedFiles.length) {
      toast.error("Add atleast 1 Document")
      return
    }

    if (!!!documentDate) {
      toast.error("Select a Date")
      return
    }

    let files = await uploadedFiles?.map(async d => {
      let t = await base64Converter(d)
      return {
        data: t,
        fileName: d.name
      }
    })

    Promise.all(files).then(function (results) {
      let temp = {
        ...data,
        DocFiles: results,
        DocumentDate: dateFormat(documentDate, "YYYY-MM-DD"),
        AddedByUserID: getCurrentUserID(),
        AddedDateTime: getDateTime(),
      }
      console.log(temp)
      setLoading(true)
      axios
        .post(
          `${SERVER_IP}DocumentOperations/save`,
          temp
        )
        .then((res) => {
          toast.success("Doc Successfully Addd");
        }).then(() => navigate("/Documents"))
        .catch((res) => {
          toast.error("Couldn't Add Documents");
        }).finally(() => setLoading(false))
    })
  };


  const removeUploadedFile = (file) => {
    let temp = uploadedFiles.filter(f => f.name !== file.name)
    setUploadedFiles(temp)
    if (temp.length === 0) {
      document.getElementById("Documents").value = ''
    }
  }

  return (

    <>
      <div style={{ marginTop: 80, display: 'flex' }}>
        <Sidebar />
        <Grid container spacing={1} style={{ padding: '10px 30px 10px 30px' }}>
          <Grid container spacing={3} style={{ margin: '10px auto', borderRadius: '10px', border: `2px solid ${PrimaryColor}` }}>
            <form style={{ width: '100%' }} onSubmit={handleSubmit(createDoc)}>
              <Grid container>
                <Grid item xs={12}>
                  <Typography style={{ backgroundColor: PrimaryColor, color: 'white' }} variant="h6" gutterBottom>
                    <AccountCircleIcon style={{ margin: 'auto 5px' }} />
                    {"Add New Doc"}
                  </Typography>
                </Grid>

                <Grid container spacing={3} style={{ margin: 'auto' }}>
                  <Grid item xs={12} sm={6}>

                    <Controller
                      name="DocName"
                      control={control}
                      defaultValue=""
                      render={({ field: { onChange, value }, fieldState: { error } }) => (
                        <TextField
                          label="Doc Name"
                          fullWidth
                          variant={inputFieldVariant}
                          value={value}
                          onChange={onChange}
                          error={!!error}
                          helperText={error ? error.message : null}
                        />
                      )}
                      rules={{ required: 'This field is required' }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>

                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        label="Document Date"
                        inputFormat="dd/MM/yyyy"
                        value={documentDate}
                        onChange={(newValue) => {
                          setDocumentDate(newValue)
                        }}
                        renderInput={(params) => <TextField
                          variant="standard"
                          id="DocumentDate"
                          name="DocumentDate"
                          fullWidth
                          {...params} />
                        }
                      />
                    </LocalizationProvider>

                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Typography>Documents (Image, PDF, Word, Excel, PPT)</Typography>
                    <input
                      type="file"
                      accept={siteImages}
                      id="Documents"
                      name="Documents"
                      multiple
                      onChange={async (e) => {
                        if (!!e.target.files?.length) {
                          let pendingFiles = []
                          let existingFiles = uploadedFiles.map(f => f.name)
                          var inp = document.getElementById('Documents');
                          for (var i = 0; i < inp.files.length; ++i) {
                            if (!existingFiles.includes(inp.files.item(i).name))
                              pendingFiles.push(inp.files.item(i))
                          }
                          if (pendingFiles.length === 0) {
                            toast.error("File(s) with same name already added")
                            e.stopPropagation();
                            return
                          }
                          setUploadedFiles([...uploadedFiles, ...pendingFiles])
                        }
                      }}
                    />
                  </Grid>

                  <Container>
                    <Row>

                      {
                        uploadedFiles?.map((d, index) => {

                          if (d?.type?.includes("image")) {
                            return <Col key={index} sm>
                              <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <Grid item xs={12}>
                                  <img
                                    title="Click to Enlarge"
                                    src={URL.createObjectURL(d)}
                                    onClick={() => {
                                      setShowImagePreview(true)
                                      setImagePreview(URL.createObjectURL(d))
                                    }}
                                    style={{ width: 'auto', height: '150px', cursor: 'pointer' }}
                                    alt="preview"
                                  />
                                  <Badge style={removeBadgeStyle} title="Remove" onClick={() => removeUploadedFile(d)} color="error" badgeContent="X">
                                  </Badge>
                                </Grid>
                                <strong>File Name : {d.name}</strong>
                              </div>
                            </Col>
                          }
                          else if (d?.type?.includes("pdf")) {
                            return <Col key={index} sm>
                              <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <Grid item xs={12}>
                                  <img
                                    title="Click To View"
                                    src={pdfIcon}
                                    style={{ width: 'auto', height: '150px', cursor: 'pointer' }}
                                    onClick={() => {
                                      window.open(URL.createObjectURL(d))
                                    }}
                                    alt="preview"
                                  />
                                  <Badge style={removeBadgeStyle} title="Remove" onClick={() => removeUploadedFile(d)} color="error" badgeContent="X">
                                  </Badge>
                                </Grid>
                                <strong>File Name : {d.name}</strong>
                              </div>
                            </Col>
                          }
                          else {
                            return <Col key={index} sm>
                              <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <Grid item xs={12}>
                                  <img
                                    title="Click to Download and View"
                                    src={docIcon}
                                    style={{ width: 'auto', height: '150px', cursor: 'pointer' }}
                                    onClick={() => {
                                      window.open(URL.createObjectURL(d))
                                    }}
                                    alt="preview"
                                  />
                                  <Badge style={removeBadgeStyle} title="Remove" onClick={() => removeUploadedFile(d)} color="error" badgeContent="X">
                                  </Badge>
                                </Grid>
                                <strong>File Name : {d.name}</strong>
                              </div>
                            </Col>
                          }
                        })
                      }

                    </Row>
                  </Container>
                </Grid>
              </Grid>

              <Grid container style={{ marginBottom: '10px' }}>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  style={{ textAlign: "center" }}
                >
                  <Button
                    disabled={loading}
                    color="primary"
                    size="small"
                    variant="contained"
                    type="submit"
                  >
                    {loading && <CircularProgress size={20} style={{ marginRight: '10px' }} />}
                    {"Create Entry"}
                  </Button>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  style={{ textAlign: "center" }}
                >
                  <Button
                    color="secondary"
                    size="small"
                    variant="contained"
                    onClick={(e) => navigate("/Documents")}>
                    Cancel
                  </Button>
                </Grid>

              </Grid>
            </form>

            <ToastContainer />
          </Grid>
        </Grid>

        <ImageViewer
          src={imagePreview}
          show={showImagePreview}
          handleClose={() => setShowImagePreview(false)}
          fileName="Documents.jpg"
        />

      </div>
    </>

  );
};
